import { render, staticRenderFns } from "./CustomerChoice.vue?vue&type=template&id=c710e896&scoped=true"
import script from "./CustomerChoice.vue?vue&type=script&lang=js"
export * from "./CustomerChoice.vue?vue&type=script&lang=js"
import style0 from "./CustomerChoice.vue?vue&type=style&index=0&id=c710e896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c710e896",
  null
  
)

export default component.exports